import { useCallback, useEffect, useRef } from 'react';

// https://webpack.js.org/migrate/5/ ( process.env.NODE_ENV is a path that gets replaced by the webpack compiler. Dont use conditionals )
const isTestEnv = process.env.NODE_ENV === 'test';
const timer = isTestEnv ? (cb: () => any) => cb() : setTimeout;

export function useDebounce<ARGS extends any[]>(callback: (...args: ARGS) => void, postpone: number = 300) {
  const argsRef = useRef<ARGS>();
  const timeout = useRef<ReturnType<typeof setTimeout>>();

  function cleanup() {
    if (timeout.current && !isTestEnv) {
      clearTimeout(timeout.current);
    }
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: exception
  useEffect(() => cleanup, []);
  // biome-ignore lint/correctness/useExhaustiveDependencies: exception
  return useCallback(
    (...args: ARGS) => {
      argsRef.current = args;
      cleanup();
      timeout.current = timer(() => {
        if (argsRef.current) {
          callback(...argsRef.current);
        }
      }, postpone);
    },
    [callback, postpone]
  );
}
